import axios from 'axios';
import {
  doctorProfileDetailURL,
  bankDetailURL,
  patientProfileDetailURL,
  getPatientMemberURL,
  patientClaimURL,
  patientPlanDetailURL,
  hospitalsURL,
  getRatingSummaryURL,
  fetchApplicationURL,
  fetchProductSpecificationURL,
  fetchDraftsClaimURL
} from '../constants';
import { toast } from 'react-toastify';
import { headers } from 'src/utils';
import { GetApi, PostApi, PutApi } from 'src/services/middleware';

export const FETCH_DOCTOR_PROFILE_SUCCESS = 'FETCH_DOCTOR_PROFILE_SUCCESS';

export const fetchDoctorProfileRequest = (data) => ({
  type: FETCH_DOCTOR_PROFILE_SUCCESS,
  payload: data
});

// fetch doctor profile details
export const fetchDoctorProfileDetail = async () => {
  try {
    const res = await GetApi(`${doctorProfileDetailURL}`, headers());
    let data = {};
    if (res.status == 200) {
      data = { ...res.data.data, ...res.data.data1 };
      return data;
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

export const fetchDoctorProfile = () => {
  return async (dispatch) => {
    try {
      const res = await GetApi(`${doctorProfileDetailURL}`, headers());
      if (res.status === 200) {
        const data = { ...res.data.data, ...res.data.data1 };
        dispatch(fetchDoctorProfileRequest(data));
        return data;
      }
    } catch (err) {
      toast.error('Something went wrong');
    }
  };
};

// update doctor profile details
export const updateDoctorProfileDetail = async (data) => {
  try {
    const res = await PutApi(`${doctorProfileDetailURL}`, data, headers());
    if (res.status == 200) {
      toast.success('Profile updated');
      return res.data;
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

// fetch doctor  profile bank details
export const fetchDoctorBankDetail = async () => {
  try {
    const res = await GetApi(`${bankDetailURL}`, headers());
    if (res.status == 200) {
      return res.data.data;
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

// update doctor profile bank details
export const updateDoctorBankDetail = async (data) => {
  try {
    const res = await PutApi(`${bankDetailURL}`, data, headers());
    if (res.status == 200) {
      toast.success('Profile updated');
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

// fetch patient profile details
export const fetchPatientProfileDetail = async (patient) => {
  try {
    const res = await GetApi(`${patientProfileDetailURL(patient)}`, headers());
    if (res.status == 200) {
      return res?.data?.data;
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

export const fetchPatientClaimDetails = async (id, sort = 'DESC') => {
  try {
    const res = await GetApi(`${patientClaimURL(id)}`, headers());
    if (res.status == 200) {
      return res.data;
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};
export const fetchPatientPlanDetails = async (id) => {
  try {
    const res = await GetApi(`${patientPlanDetailURL}/${id}`, headers());
    if (res.status == 200) {
      return res.data;
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

export const fetchHospitalDetails = async () => {
  try {
    const res = await GetApi(`${hospitalsURL}`, headers());
    if (res.status == 200) {
      return res.data.data;
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

// fetch patient member details
export const fetchPatientMemberDetail = async (user_id) => {
  try {
    const res = await GetApi(`${getPatientMemberURL(user_id)}`, headers());
    if (res.status == 200) {
      return res;
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

// fetch patient member details
export const fetchRatingDetail = async (user_id) => {
  try {
    const res = await GetApi(`${getRatingSummaryURL(user_id)}`, headers());
    if (res.status == 200) {
      return res;
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

//fetch subscription details
export const fetchSubscriptionDetails = async (applicationId) => {
  try {
    const res = await GetApi(
      `${fetchApplicationURL(applicationId)}`,
      headers()
    );
    if (res.status == 200) {
      return res;
    }
  } catch (error) {
    console.log(error);
  }
};

//fetch product specification
export const fetchProductSpecification = async (claimId, subClaimId) => {
  try {
    const res = await GetApi(
      `${fetchProductSpecificationURL(claimId, subClaimId)}`,
      headers()
    );
    if (res.status == 200) {
      return res;
    }
  } catch (error) {
    console.log(error);
  }
};

//fetch claims in draft
export const fetchDraftClaimsInfo = async (claimId, resellerId) => {
  try {
    const res = await GetApi(
      `${fetchDraftsClaimURL(claimId, resellerId)}`,
      headers()
    );
    if (res.status == 200) {
      return res.data;
    }
  } catch (error) {
    console.log(error);
  }
};
